import { inverseSubtleText } from "./PageFooter.styles";

export const getSubtleFootnoteProps = (isInverseTheme: boolean) => {
  if (isInverseTheme) {
    return {
      variant: "footnote" as const,
      intention: "inverse" as const,
      customCss: inverseSubtleText,
    };
  }

  return {
    variant: "footnote" as const,
    intention: "neutral" as const,
    colorIntensity: "subtle" as const,
  };
};
